export { default } from './es/icons/PdfTwoTone';